import { useState } from 'react'
import { styles } from '@/shell/layout.styles'

export function DropdownButton({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
  const [hovered, setHovered] = useState(false)
  return (
    <button
      style={{ ...styles.dropdownItem, ...(hovered ? styles.dropdownItemHover : {}) }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </button>
  )
}

